export const CONSTANTS={
    ADD_PATIENT:'ADD_PATIENT',
    ALL_PATIENTS:'ALL_PATIENTS',
    BOOK_APPOINTMENT:'BOOK_APPOINTMENT',
    ALL_APPOINTMENTS:'ALL_APPOINTMENTS'
}


// WEBPACK FOOTER //
// ./src/pages/constants.js